export default __webpack_public_path__ + "static/squiggle-495e14fa435f126326b679a314525d1f.png";